import React from 'react'

import FieldError from '@/Form/FieldError'
import Checkbox   from '@/Form/V2/Managed/CheckboxEl'

import bemit from '@function/bemit'

import { formatNum, num } from '@root/utility'

import FormsStore from '@Store/Forms'

const header =
[
	{ name: 'cb' },
	{ name: 'text_number', label: 'Numéro' },
	{ name: 'total_amount', label: 'Montant avoir' },
	{ name: 'remaining_amount', label: 'Reste à affecter' }
];

function handleCbChange (form, credit_note)
{
	FormsStore.update(function (store)
	{
		store[form] ||= { };

		store[form].to_affect ||= [];

		if (store[form].to_affect.some(({ id }) => id === credit_note.id))
		{
			store[form].to_affect = store[form].to_affect
			.filter(data => data.id !== credit_note.id);
		}
		else
		{
			store[form].to_affect = store[form].to_affect.concat(
			[
				{
					id: credit_note.id,
					affectable: num(credit_note.remaining_unpaid)
				}
			]);
		}

		store[form].total_to_affect = store[form].to_affect
		.reduce(function (total, credit_note)
		{
			return num(total + num(credit_note.affectable));
		},
		num(store[form].amount));
	});
}

export default function CreditNotesToAffect ({ list=[], ...props })
{
	const to_affect = FormsStore.useState(s => s[props.form]?.to_affect || []);

	let active_i = 0;

	if (!list?.length) return null;

	const credit_notes = list.map(function (credit_note)
	{
		const errors = props.status?.fields || { };

		const is__checked = to_affect.some(({ id }) => id === credit_note.id);

		const status_i = is__checked ? active_i : '-1';

		const pattern = 'to_affect[' + status_i + '][';

		if (is__checked) active_i += 1;

		return (
			<div className="c-to-affect__row" key={ credit_note.id }>

				<div className="c-to-affect__cell CN-cb">
					<Checkbox name={ credit_note.id } bemit={ ['in-cell'] }
						checked={ is__checked }
						onChange={ () => handleCbChange(props.form, credit_note) }
					/>
				</div>

				<div className="c-to-affect__cell CN-text_number">
					{ credit_note.text_number }

					<FieldError error={ errors[pattern + 'id]']?.error } />
				</div>

				<div className="c-to-affect__cell CN-total_amount">
					{ formatNum(credit_note.total_price, '0,0[.]00') }
					&nbsp;€
				</div>

				<div className="c-to-affect__cell CN-remaining_amount">
					{ formatNum(credit_note.remaining_unpaid, '0,0[.]00') }
					&nbsp;€

					<FieldError
						error={ errors[pattern + 'affectable]']?.error }
					/>
				</div>

			</div>
		);
	});

	const header_cells = header.map(function ({ name, label })
	{
		return (
			<div className={ 'c-to-affect__cell CN-' + name } key={ name }>
				{ label }
			</div>
		);
	});

	return (
		<div className={ bemit('c-to-affect', ['credit-note']) }>

			<div className="c-to-affect__title">
				Avoirs à affecter
			</div>

			<div className="c-to-affect__row is-head-row">
				{ header_cells }
			</div>

			{ credit_notes }

		</div>
	);
}